import icons from '../assets/icons/icons.js';

const variations = [
	{
		name: 'default',
		title: 'Default',
		attributes: {
			class: 'default',
		},
		icon: icons.default,
	},
	{
		name: 'top-centred',
		title: 'Top centred',
		attributes: {
			class: 'top-centred',
		},
		icon: icons.topCentre,
	},
	{
		name: 'centred',
		title: 'Centered',
		attributes: {
			class: 'centred',
		},
		icon: icons.centred,
	},
	{
		name: 'closed',
		title: 'Closed',
		attributes: {
			class: 'closed',
		},
		icon: icons.closed,
	},
	{
		name: 'block-quotation',
		title: 'Block quotation',
		attributes: {
			class: 'block-quotation',
		},
		icon: icons.blockQuotation,
	},
];

export default variations;
